<script lang="ts">
  import {deal, displayLogo, dealId} from 'Store/InvestorFlowStore';
  import {embeddedWebComponent} from 'Store/embedded/embeddedFlowStore';
  import {embedOptions} from 'Store/EmbedOptionsStore';
  import ProductPageForm from 'Components/InvestorFlow/v2/Components/LeftContainer/ProductPageForm.svelte';
  import {whiteLabeling} from 'Store/WhiteLabelStore';
  import ProductPageDetails from './Components/ProductPageDetails/ProductPageDetails.svelte';
  import {onMount} from 'svelte';

  onMount(() => {
    document.dispatchEvent(
      new CustomEvent('GTM-EVENT:traffic', {
        bubbles: true,
        detail: {
          dealUuid: $dealId,
        },
      })
    );
  });
</script>

<div class="product-page-container" data-testid="product-page-v2">
  {#if $displayLogo}
    <div class="header">
      {#if $whiteLabeling.primary_logo}
        <img
          src={$whiteLabeling.primary_logo}
          alt="{$deal.company.name} Logo"
        />
      {/if}
    </div>
  {/if}
  {#if $deal.setting.landing_header}
    {#if !$embeddedWebComponent || ($embeddedWebComponent && $embedOptions.displayLandingHeader)}
      <div class="invitation-title">
        <h3>
          {$deal.setting.landing_header}
        </h3>
      </div>
    {/if}
  {/if}
  <div
    class="body"
    class:hideProductDetails={$embedOptions.hideProductDetails}
    data-testid="product-page-body"
  >
    <div class="container-right">
      <ProductPageDetails />
    </div>
    <div class="container-left">
      <div class="main-content" data-testid="main-content">
        <div class="question-group">
          <ProductPageForm />
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  .product-page-container {
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    margin-bottom: 2rem;
    background-color: var(
      --dm-bg-primary-color,
      var(--palettes-neutral-0, #ffffff)
    );
    width: unset;

    @media screen and (min-width: 768px) {
      margin-left: auto;
      margin-right: auto;
    }

    @media screen and (min-width: 992px) {
      max-width: 60rem;
    }
  }

  .invitation-title {
    margin: 0 1.75rem;
    padding: 0.75rem 0;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: left;
    margin: 0 1.75rem;
    padding-top: 1rem;
    padding-bottom: 1rem;

    & img {
      max-height: 2.5rem;
      align-self: start;
    }
  }

  .body {
    display: flex;
    border: 1px solid var(--palettes-neutral-75, #eaecf0);
    min-height: 28.3rem;
    height: auto;
    border-radius: 0.25rem;
    flex-direction: column;
    align-items: center;

    @media screen and (min-width: 768px) {
      flex-direction: row-reverse;
      justify-content: left;
      align-items: initial;
    }
  }

  .container-left {
    display: flex;
    flex-direction: column;
    justify-content: left;
    width: 100%;
    background-color: var(
      --dm-bg-primary-color,
      var(--palettes-neutral-25, #fcfcfd)
    );
    border-top: 1px solid var(--palettes-neutral-75, #eaecf0);
    border-right: none;
    align-items: center;

    @media screen and (min-width: 768px) {
      border-top: none;
      border-right: 1px solid var(--palettes-neutral-75, #eaecf0);
      width: 25rem;
      align-items: left;
    }
  }

  .container-right {
    display: flex;
    flex-direction: column;
    justify-content: left;
    width: 100%;
    padding: 0.75rem 1.75rem;

    @media only screen and (min-width: 768px) {
      padding-top: 1rem;
      padding-bottom: 1rem;
    }

    @media only screen and (min-width: 992px) {
      padding-left: 2rem;
      padding-right: 2rem;
      width: 35rem;
    }
  }

  .main-content {
    width: 100%;

    @media only screen and (min-width: 575px) {
      width: unset;
    }

    @media only screen and (min-width: 768px) {
      width: 23.75rem;
    }
  }

  .question-group {
    padding: 0.75rem 1.75rem;
    border-radius: 0.25rem;

    @media only screen and (min-width: 768px) {
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
  }

  .hideProductDetails {
    border: none;

    @media screen and (min-width: 768px) {
      justify-content: center;
    }

    & .container-right {
      display: none;
    }

    & .container-left {
      width: 100%;
      border: none;
      background-color: var(--dm-bg-primary-color, var(--palettes-neutral-0));
    }
  }
</style>
